import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";

const NAV_ITEMS = [
  {
    label: "Create Bills",
    icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2"/><rect x="9" y="3" width="6" height="4" rx="1"/><line x1="9" y1="12" x2="15" y2="12"/></svg>,
    path: "/billing",
  },
  {
    label: "Insurance Claims",
    icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>,
    path: undefined as string | undefined,
  },
  {
    label: "Expenses & Salaries",
    icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/></svg>,
    path: "/accounting/expenses",
  },
] as const;

export const BillingSidebar: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const items = NAV_ITEMS.map((item) => ({
    ...item,
    active: item.path ? location.pathname.startsWith(item.path) : false,
    onClick: item.path
      ? () => navigate(item.path as string)
      : () => toast.info(`${item.label} — coming soon.`),
  }));

  return (
    <>
      {/* Mobile: horizontal scrollable strip */}
      <div className="flex md:hidden border-b border-[rgba(206,250,254,0.5)] bg-gradient-to-r from-[rgba(236,254,255,0.5)] to-[rgba(239,246,255,0.3)] px-3 py-2 gap-2 overflow-x-auto shrink-0">
        {items.map((item) => (
          <button
            key={item.label}
            onClick={item.onClick}
            className={`flex items-center gap-2 h-9 px-3 rounded-[10px] shrink-0 text-sm font-medium whitespace-nowrap transition ${
              item.active
                ? "bg-gradient-to-r from-[#00b8db] to-[#2b7fff] text-white shadow-sm"
                : "text-[#314158] hover:bg-white/40"
            }`}
          >
            {item.icon}
            {item.label}
          </button>
        ))}
      </div>
      {/* Desktop: vertical sidebar */}
      <aside className="hidden md:flex w-[220px] shrink-0 border-r border-[rgba(206,250,254,0.5)] bg-gradient-to-b from-[rgba(236,254,255,0.5)] to-[rgba(239,246,255,0.3)] px-4 py-6 flex-col gap-2">
        {items.map((item) => (
          <button
            key={item.label}
            onClick={item.onClick}
            className={`flex items-center gap-3 h-11 px-4 rounded-[14px] w-full text-sm font-medium text-left transition ${
              item.active
                ? "bg-gradient-to-r from-[#00b8db] to-[#2b7fff] text-white shadow-[0px_4px_8px_rgba(0,184,219,0.3)]"
                : "text-[#314158] hover:bg-white/40"
            }`}
          >
            <span className={item.active ? "text-white" : ""}>{item.icon}</span>
            {item.label}
          </button>
        ))}
      </aside>
    </>
  );
};

export default BillingSidebar;
